import SingleTransactionInfo from './SingleTransactionInfo/SingleTransactionInfo'

export const SingleTransaction = {
    Info: SingleTransactionInfo
}

export default SingleTransaction